import React, {useEffect, useState} from 'react';
import {InitialValueType} from './initial-value';

const TextAreaInitialValue = ({value, onChange, radioBoxName}) => {

  const [model, setModel] = useState(null);

  const setModelAndNotify = newModel => {
    setModel(newModel);
    onChange(newModel);
  }

  useEffect(() => {
    if (!value.type) {
      setModelAndNotify({
        ...value,
        type: InitialValueType.TEXT,
        text: value.text || ''
      });
    } else {
      setModel(value);
    }
  }, [ value ]);

  if (!model) {
    return <div></div>
  } else {
    return <div>
      <div className="form-check">
        <input type="radio"
               name={radioBoxName}
               id={radioBoxName + 'InitialValueText'}
               className="form-check-input"
               value={InitialValueType.TEXT}
               checked={model.type === InitialValueType.TEXT}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label className="form-check-label" htmlFor={radioBoxName + 'InitialValueText'}>
          Text value
        </label>
      </div>
      {model.type === InitialValueType.TEXT &&
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <div className="mb-3">
                <textarea className="form-control"
                          placeholder="Enter an initial value"
                          value={model.text || ''}
                          onChange={e => setModelAndNotify({...model, text: e.target.value})}/>
          </div>
        </div>
      </div>
      }
      <div className="form-check">
        <input type="radio"
               name={radioBoxName}
               id={radioBoxName + 'InitialValueJavascript'}
               className="form-check-input"
               value={InitialValueType.JAVASCRIPT}
               checked={model.type === 'JAVASCRIPT'}
               onChange={e => setModelAndNotify({...model, type: e.target.value})}/>
        <label className="form-check-label" htmlFor={radioBoxName + 'InitialValueJavascript'}>
          Use Javascript
        </label>
      </div>
      {model.type === InitialValueType.JAVASCRIPT &&
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <div className="mb-3">
              <textarea className="form-control" style={{minHeight: '8em'}}
                        placeholder="var otherField = $('#other-field'); otherField.val();"
                        value={model.javascript || ''}
                        onChange={e => setModelAndNotify({...model, javascript: e.target.value})}/>
          </div>
        </div>
      </div>
      }
    </div>;
  }

};

export default TextAreaInitialValue;
